import { useMutation, useQuery } from "@tanstack/react-query";
import { Script } from "gatsby-script";
import React from "react";
import { Helmet } from "react-helmet";
import { sniffLocation } from "../hooks/useFormValuesFromURL";
import { trackCustomEvent } from "../utils/analytics";

const DOMAIN = process.env.GATSBY_DOMAIN;

export default function IndeedWidget({
  indeedWidgetContainerId,
  eventCategory,
  position,
  location,
}: {
  indeedWidgetContainerId: `indeed-widget-path` | `indeed-widget-serp`;
  eventCategory: "Path" | "SERP";
  position: string;
  location: string;
}) {
  const { data } = useQuery(
    [`https://api-v2.${DOMAIN}/whif`],
    async () => {
      const sniffedLocation = await sniffLocation();
      const { cityName, region } = sniffedLocation ?? {};
      if (!cityName && !region) {
        return location;
      }
      return `${cityName},${region}`;
    },
    {
      staleTime: 0,
      cacheTime: 0,
    }
  );
  const locationSniffed = data ?? location;
  const mutation = useMutation({
    mutationFn: () => {
      window.SpWidgets?.tmnOnLoadWidgetInit({
        q: position,
        l: location,
        c: indeedWidgetContainerId,
        pn: "1959900354627556",
        api: "https://sprj.indeed.com/api/v1/jobs",
      });
    },
  });

  return (
    <>
      <Helmet>
        <link
          rel="stylesheet"
          href="https://prod.statics.indeed.com/tmn/sp-relevant-jobs-widget/v1/css/style.css"
        ></link>
        <link
          rel="preload"
          href={`https://sprj.indeed.com/api/v1/jobs?q=${position}&l=${locationSniffed}&pn=1959900354627556`}
        />
      </Helmet>
      <Script
        src="https://prod.statics.indeed.com/tmn/sp-relevant-jobs-widget/v1/js/WidgetScript.client.js"
        strategy="idle"
        onLoad={() => {
          mutation.mutate();
        }}
      />
      <div
        className="grid place-content-center"
        onClick={(event) => {
          const href = (event.target as HTMLAnchorElement).closest("a")?.href;
          if (href) {
            trackCustomEvent({
              action: "Job Click (Indeed Widget)",
              category: eventCategory,
              label: href,
            });
          }
        }}
      >
        <div id={indeedWidgetContainerId} className="tmn-widget"></div>
      </div>
    </>
  );
}

// export default IndeedWidget
